<template>
  <!-- rankings -->
  <div>
    <h2>{{ $t('tournaments.tprStandings') }} {{activeRoundNumber}}</h2>

    <div class="groupSection" v-for="group in tournament.groups"
          :key="group.groupId"
          :group="group">
      <div v-if="tournament.groups.length > 1"><font-awesome-icon icon="users" class=""/> {{group.name}}</div>
      <div v-if="groupRankings(group.groupId).length == 0 ">Nog aan te vullen</div>
      <div v-if="rankings.length > 0">
        <table class="result-table"><tbody>
          <tr class="result-header">
            <td class="tdSpace">#</td>                         
            <td>{{ $t('tournaments.name') }}</td>                         
            <td :title="$t('tournaments.eloTitle')">{{ $t('tournaments.elo') }}</td>                         
            <td :title="$t('tournaments.tprTitle')">{{ $t('tournaments.tpr') }}</td>                         
            <td :title="$t('tournaments.tprGainTitle')">{{ $t('tournaments.tprGain') }}</td>                         
          </tr>

          <tr class="result-row" v-for="ranking in groupRankings(group.groupId)"
                                    :key="ranking.rankingId" 
                                    :ranking="ranking">
            <td class="tdSpace">{{ranking.rank}}</td>                         
            <td>{{ranking.participant.person.name}}</td>                         
            <td>{{ranking.participant.startingElo}}</td>                         
            <td class="visibleIfSpaceAvailable">{{ranking.tpr}}</td>                         
            <td class="visibleIfSpaceAvailable">{{ranking.tprGain}}</td>                         
          </tr>
        </tbody></table>
      </div>  
    </div>    
  </div>
</template>

<script>

export default {
  name: 'ResultTPRRanking',
  components: {},
  props: {
    rankings: { type: Array, required: false, default: () => [{ rankingId: 0, name: "No rannkings provided" }] },
    tournament: Object,
    activeRoundNumber: Number,
    managementFunctions: Boolean
  },
  data: function () {
    return {
      roundId: -1
    }
  },
  methods: {
    groupRankings: function(groupId) {
      return this.rankings.filter(m => m.groupId == groupId);
    }
  }
}
</script>

<style scoped>

  .center {
    text-align: center;
  }

  .columnspace {
    padding-right: 16px;
  }
  
  .imgbtn {
    text-decoration: none;
    float: right;
    border: 1px solid #333333;
    border-radius: 2px;
    margin-left: 4px;
  }

  select {
    border-radius: 2px;
  }

  .tdSpace {
    margin: 0 2px;
  }

/* mobile */
@media screen and (max-width: 600px) {

  .visibleIfSpaceAvailable {
    display: none;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {

  .visibleIfSpaceAvailable {
    display: table-cell;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .visibleIfSpaceAvailable {
    display: table-cell;
  }
}

</style>
